import React from 'react'
import { Card } from 'antd'
import './revenue.widget.scss'

const RevenueWidget = ({ type, showType, currency, amount }: any) => {
    return (
        <Card
            className={`dashboard-widget rev-widget vsplit type-${type?.toLowerCase() ?? 'content'}`}
            title={showType !== false && type ? `${type} Revenue` : 'Revenue'}
            size="small"
            styles={{
                title: { textAlign: 'center' },
                body: { padding: 0 },
            }}
        >
            <div className="dashboard-widget-content">
                <div className="widget-body yesterday">
                    <div className="widget-sub-title">
                        <label>Yesterday</label>
                    </div>
                    <span className="revenue">
                        {amount === undefined
                            ? '--'
                            : Intl.NumberFormat('en-us', {
                                  style: 'currency',
                                  currency: currency ?? 'usd',
                              }).format(amount ?? 0)}
                    </span>
                </div>
            </div>
        </Card>
    )
}

export default RevenueWidget
